export const GOOGLE_MAPS_API_KEY = "AIzaSyDU8YggCshOvYWkSN6Ui-1P7LJ_QPSzRc0";
